import { deviceManagementApis } from './management/apis';
import { deviceShipmentApis } from './shipment/apis';
import { deviceServiceApis } from './service/apis';

export const deviceApis = {
  shipment: deviceShipmentApis,
  management: deviceManagementApis,
  service: deviceServiceApis,
};
